import { render, staticRenderFns } from "./OxygenNumberInput.vue?vue&type=template&id=1ff6873b&"
import script from "./OxygenNumberInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports